import type { SelfDescribingJson } from '@snowplow/browser-tracker';

import type { BuildSmidContextParameters } from './build-smid-context.types';

/**
 * Builds the `smid` Snowplow context entity, carrying the SMID observed from
 * the current page's URL query parameter and/or its compliance footer.
 * Attached to page view and user-click events so every SMID a consumer is
 * exposed to (not just the last-touch value) is captured for attribution.
 *
 * @param parameters - See {@link BuildSmidContextParameters}.
 *
 * @example
 * ```ts
 * import { buildSmidContext } from '@hc-frontend/third-party-snowplow';
 *
 * buildSmidContext({
 *   smidUrlParam: 'MULTIPLAN_PYHC26-201_C',
 *   smidPageFooter: 'MULTIPLAN_PYHC26-103_C',
 * });
 * ```
 */
export function buildSmidContext({
  smidUrlParam,
  smidPageFooter,
}: BuildSmidContextParameters): SelfDescribingJson {
  return {
    schema: 'iglu:com.healthcare/smid/jsonschema/1-0-0',
    data: {
      smid_url_param: smidUrlParam ?? null,
      smid_page_footer: smidPageFooter ?? null,
    },
  };
}
